import Modal from 'utils/packages/Modal';
const RentReportingLinkedModal = {
    show: (entity, action, onProceed) => {
        Modal.showConfirmation({
            title: `This ${entity} reports your rent`,
            subtitle: `This ${entity} tracks your rent payments to help build your credit history. If you ${action} it now, we won’t be able to report your rent payments`,
            confirmButtonTitle: 'Close anyway',
            cancelButtonTitle: 'Keep tracking rent',
            onConfirm: onProceed,
        });
    },
    hide: Modal.hide,
};
export default RentReportingLinkedModal;
